
import { useEffect, useState } from 'react';
import { Autocomplete, TextField } from "@mui/material"





export const AutocompleteNombre = ({ label, options=[], onChange, bloqueo=false, ...props }) => {


    const [selectNombre, setSelectNombre] = useState(null);


    useEffect(() => {
        setSelectNombre(props.value);
    }, [props.value]);


    const handleChange = (_, newValue) => {
        setSelectNombre(newValue ? newValue.id : null);
        if (onChange) {
            onChange(newValue);
        }
    }



    return (
        <>
            <Autocomplete
                disabled={bloqueo}
                value={options.find(valor => (valor._id || valor.id) === selectNombre) || null}
                options={ options }
                onChange={ (event, newValue) => handleChange(event, newValue)}
                getOptionLabel={(option) => option.nombre.toString()}
                isOptionEqualToValue={(option, value) => 
                    (option.id || option._id) === (value.id || value._id)
                }
                renderOption={(props, option) => {
                    const { key, ...otherProps } = props;
                    return ( <li key={key} {...otherProps}> {option.nombre}</li> );
                }}
                renderInput={(params) => <TextField
                    disabled={bloqueo}
                    {...params} 
                    label={ label }  
                    { ...props }
                    autoComplete="off"
                    fullWidth
                />}
            />
        </>

    )
}


